import React from 'react';
import {
  createOrderSetting,
  updateOrderSetting,
  notificationSetting,
} from 'actions/setting/';
import {
  INTEGRATION,
  ORDER_SETTING,
  SETTING_MODAL,
  EMAIL_NOTIFICATION_SETTING,
} from 'constants/modal';
import {
  createIntegration,
  deleteIntegration,
  updateIntegration,
} from 'actions/integration/';
import { Tab } from 'components/Tab/';
import Modal from 'containers/Modal/Modal';
import { clearModal } from 'actions/modals/';
import { showConfirm } from 'actions/confirm/';
import { DELETE_INTEGRATION } from 'actions/types';
import { INVOICE_NINJA } from 'constants/inventory';
import { useDispatch, useSelector } from 'react-redux';
import { Order, Accounting, EmailNotification } from 'components/Settings/';

export function SettingModal() {
  let modalLeft = 20;
  let modalWidth = 50;
  let component = null;
  let modalCaption = '';
  let removeWhiteBackGround = false;
  const dispatch = useDispatch();
  const user = useSelector(({ user }) => user);
  const modal = useSelector(({ modal }) => modal);
  const { type = '', initialValue } = modal || {};
  const isOpen = type === SETTING_MODAL;
  const { action } = initialValue || {};
  const { data: integration } = useSelector((s) => s.integration);
  const orderSetting = useSelector(({ orderSetting }) => orderSetting);
  const { notification_settings: notificationSettings } = user || {};
  const { emails } = notificationSettings || {};
  const invoiceNinja = integration?.find((i) => i.type === INVOICE_NINJA);

  if (action === ORDER_SETTING) {
    modalLeft = 20;
    modalWidth = 60;
    modalCaption = 'Order Settings';
    component = (
      <Order
        onClose={onClose}
        onSubmit={onSubmitOrderSetting}
        initialValue={orderSetting && orderSetting[0]}
      />
    );
  }
  if (action === EMAIL_NOTIFICATION_SETTING) {
    modalLeft = 30;
    modalWidth = 40;
    modalCaption = 'Email Notification Settings';
    component = (
      <EmailNotification
        emails={emails}
        onClose={onClose}
        onSubmit={onSubmitEmailSetting}
      />
    );
  }
  if (action === INTEGRATION) {
    modalLeft = 20;
    modalWidth = 60;
    removeWhiteBackGround = true;
    modalCaption = 'Integration Settings';
    const tabs = [
      {
        name: 'accounting',
        caption: 'Accounting',
        children: (
          <Accounting
            onSubmit={onSubmitIntegration}
            onDelete={onDeleteIntegration}
            initialInvoiceNinja={invoiceNinja}
          />
        ),
      },
    ];
    component = <Tab options={tabs} />;
  }

  function onClose() {
    dispatch(clearModal(SETTING_MODAL));
  }

  function onSubmitEmailSetting(payload) {
    dispatch(notificationSetting(payload));
  }

  function onDeleteIntegration(id, data) {
    dispatch(
      showConfirm({
        type: DELETE_INTEGRATION,
        title: 'Permanently delete integration setting',
        onConfirm: function () {
          dispatch(deleteIntegration(id, data));
        },
        caption: `Are you sure you want to integration setting ?`,
      }),
    );
  }

  function onSubmitIntegration(data, type, id) {
    if (type === INVOICE_NINJA) {
      if (id) {
        dispatch(updateIntegration(id, data));
      } else {
        dispatch(createIntegration(data));
      }
    }
  }

  /**
   * @param {string} id
   * @param {{}} payload
   */
  function onSubmitOrderSetting(payload, id) {
    const { company_id: companyId } = user;
    const data = { ...payload, company_id: companyId };
    if (id) {
      const data = { ...payload, id };
      dispatch(updateOrderSetting(id, data));
    } else {
      dispatch(createOrderSetting(data));
    }
  }

  return (
    <Modal
      modalTop={5}
      isOpen={isOpen}
      onClose={onClose}
      modalLeft={modalLeft}
      caption={modalCaption}
      modalWidth={modalWidth}
      removeWhiteBackGround={removeWhiteBackGround}
    >
      {component}
    </Modal>
  );
}
